import { fetchPerms } from '../../api/auth'

export default {
  data() {
    return {
      permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (String(user.roleCode || '') === 'TENANT_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || String(user.roleCode || '') === 'PLATFORM_ADMIN' || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    }
  }
}
